import React from 'react';
import { useTranslation } from 'react-i18next';

export function ColumnStatus ({ type, text }) {
    const { t } = useTranslation();
    const formattedText = /\..*\./.test(text) ? t(text) : text;
    return (<span style={{ padding: '0rem' }} className={type ? `label label-light-${type} label-pill label-inline` : ''}>{formattedText}</span>);
}

// Set display names for debugging.
if (process.env.NODE_ENV !== 'production') {
    ColumnStatus.displayName = 'ColumnStatus';
}
